export default __webpack_public_path__ + "static/media/a004-a.b79389e5.jpg";